import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { Spinner } from '../components/common/Spinner';

export function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  usePushNotifications(!loading && !!user);

  if (loading) {
    return <Spinner fullPage />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
